import { render, staticRenderFns } from "./OTPVerification.vue?vue&type=template&id=51e70ce3"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports